import * as _ from 'lodash';
import { MissionType } from '../objects/MissionType';

function createCriteria(source) {
    let defaultCriteria = {
        Archived: 0,
    };

    return _.extend(defaultCriteria, _.cloneDeep(source));
}

angular.module("tromanWeb").controller('MissionTypesController', ['stateService', 'tromanServer', 'dialogService', function (stateService, tromanServer, dialogService) {

    this.loading = true;
    this.showAdvancedSearch = false;
    this.table = null;
    this.items = null;

    this.$onInit = function $onInit() {
        const params = stateService.getParams();

        this.filter = params.filter;
        this.criteria = createCriteria(params.criteria);
        this.showAdvancedSearch = params.criteria != null;

        this._refresh();
    };

    this.uiOnParamsChanged = function (changed) {
        if (_.has(changed, 'criteria')) {
            this.criteria = createCriteria(changed.criteria);
            this._refresh();
        }

        if (_.has(changed, 'filter')) {
            this.filter = changed.filter;
        }
    };

    this.search = function search() {
        stateService.reloadWithParams({ criteria: _.cloneDeep(this.criteria) });
    };

    this.filterChanged = function filterChanged() {
        stateService.replaceParams({ filter: this.filter });
    };

    this._refresh = function _refresh() {
        this.loading = true;
        tromanServer.MissionTypes.search(this.criteria).then(data => {
            this.error = null;
            this.items = data;
        }).catch(err => {
            this.error = err;
            this.items = null;
        }).finally(() => {
            this.loading = false;
        });
    };

    this.createList = function createList() {
        if (this.table == null) return;
        var list = this.table.selectedItems();
        dialogService.createMissionTypeList(list);
    };

    this.add = function add() {
        dialogService.editMissionType(new MissionType()).then(() => this._refresh());
    };

    this.edit = function edit(item) {
        dialogService.editMissionType(item).then(() => this._refresh());
    };

}]);
